// Liste d'indicatifs téléphoniques internationaux
export const DIAL_CODES = [
  { code: "+33", flag: "🇫🇷", name: "France" },
  { code: "+32", flag: "🇧🇪", name: "Belgique" },
  { code: "+41", flag: "🇨🇭", name: "Suisse" },
  { code: "+352", flag: "🇱🇺", name: "Luxembourg" },
  { code: "+377", flag: "🇲🇨", name: "Monaco" },
  { code: "+1", flag: "🇨🇦", name: "Canada / USA" },
  { code: "+44", flag: "🇬🇧", name: "Royaume-Uni" },
  { code: "+34", flag: "🇪🇸", name: "Espagne" },
  { code: "+351", flag: "🇵🇹", name: "Portugal" },
  { code: "+39", flag: "🇮🇹", name: "Italie" },
  { code: "+49", flag: "🇩🇪", name: "Allemagne" },
  { code: "+31", flag: "🇳🇱", name: "Pays-Bas" },
  { code: "+212", flag: "🇲🇦", name: "Maroc" },
  { code: "+213", flag: "🇩🇿", name: "Algérie" },
  { code: "+216", flag: "🇹🇳", name: "Tunisie" },
  { code: "+221", flag: "🇸🇳", name: "Sénégal" },
  { code: "+225", flag: "🇨🇮", name: "Côte d'Ivoire" },
  { code: "+237", flag: "🇨🇲", name: "Cameroun" },
  { code: "+243", flag: "🇨🇩", name: "RD Congo" },
  { code: "+261", flag: "🇲🇬", name: "Madagascar" },
  { code: "+262", flag: "🇷🇪", name: "Réunion" },
  { code: "+590", flag: "🇬🇵", name: "Guadeloupe" },
  { code: "+596", flag: "🇲🇶", name: "Martinique" },
  { code: "+594", flag: "🇬🇫", name: "Guyane" },
  { code: "+687", flag: "🇳🇨", name: "Nouvelle-Calédonie" },
  { code: "+689", flag: "🇵🇫", name: "Polynésie fr." },
  { code: "+352", flag: "🇱🇺", name: "Luxembourg" },
  { code: "+30", flag: "🇬🇷", name: "Grèce" },
  { code: "+43", flag: "🇦🇹", name: "Autriche" },
  { code: "+45", flag: "🇩🇰", name: "Danemark" },
  { code: "+46", flag: "🇸🇪", name: "Suède" },
  { code: "+47", flag: "🇳🇴", name: "Norvège" },
  { code: "+48", flag: "🇵🇱", name: "Pologne" },
  { code: "+90", flag: "🇹🇷", name: "Turquie" },
  { code: "+971", flag: "🇦🇪", name: "Émirats A.U." },
  { code: "+961", flag: "🇱🇧", name: "Liban" },
  { code: "+20", flag: "🇪🇬", name: "Égypte" },
  { code: "+86", flag: "🇨🇳", name: "Chine" },
  { code: "+91", flag: "🇮🇳", name: "Inde" },
  { code: "+81", flag: "🇯🇵", name: "Japon" },
];
